import { Skeleton } from "@offstreetparking/design-system/feedback";
import { CircleCheckIcon } from "@offstreetparking/design-system/icons/CircleCheckIcon";
import { LocationIcon } from "@offstreetparking/design-system/icons/LocationIcon";
import { Text } from "@offstreetparking/design-system/typography";
import Image from "next/image";

export const ConfirmationSkeleton = () => {
	return (
		<div>
			<div className="flex flex-col gap-4 p-8">
				<div className="flex items-center justify-center gap-2">
					<CircleCheckIcon className="h-9 w-9 text-success" />
					<Skeleton height={32} width={192} />
				</div>
				<div>
					<div className="flex justify-center gap-2 rounded-t-md bg-black p-2">
						<Skeleton height={20} width={128} className="bg-neutral-faded" />
					</div>
					<div className="flex items-center justify-center gap-2 rounded-b-md bg-primary p-2">
						<Skeleton height={32} width={192} className="bg-primary-faded" />
						<Skeleton height={32} width={32} className="bg-primary-faded" />
					</div>
				</div>
				<div className="flex flex-col items-center gap-4">
					<div className="flex flex-col items-center gap-2">
						<Skeleton height={20} width={456} />
						<Skeleton height={20} width={256} />
					</div>

					<div className="w-full">
						<Skeleton height={48} className="w-full" />
					</div>
				</div>
			</div>
			<div className="w-full">
				<div className="space-y-8 bg-neutral-faded p-4">
					<div className="flex flex-col gap-4">
						<Skeleton height={24} width={128} />
						<div className="flex gap-4">
							<LocationIcon className="h-6 text-disabled" />
							<div className="flex-1">
								<Skeleton height={24} width={192} />
								<Skeleton height={16} width={128} className="mt-1" />
							</div>
							<Skeleton height={32} width={96} />
						</div>
					</div>

					<div className="flex items-stretch justify-between gap-4">
						<div className="flex flex-1 flex-col items-center gap-2 rounded-md border border-neutral-faded bg-white p-4">
							{/* Empty alt text because the image is decorative */}
							<Image
								src="https://offstreet.s3.us-west-2.amazonaws.com/email/plates-instructions-interchangeable.png"
								alt=""
								width={120}
								height={56}
								sizes="120px"
							/>
							<Skeleton height={16} className="w-full" />
						</div>
						<div className="flex flex-1 flex-col items-center gap-2 rounded-md border border-neutral-faded bg-white p-4">
							{/* Empty alt text because the image is decorative */}
							<Image
								src="https://offstreet.s3.us-west-2.amazonaws.com/email/digital-instructions-interchangable.png"
								alt=""
								width={120}
								height={56}
								sizes="120px"
							/>
							<Skeleton height={16} className="w-full" />
						</div>
					</div>
				</div>
				<div className="flex flex-col gap-8 p-4">
					<Text size="md" className="font-bold text-primary">
						<Skeleton height={24} width={192} />
					</Text>

					{/* Time */}
					<div className="flex gap-4">
						<Skeleton height={24} width={24} type="circle" />
						<div className="flex-1">
							<Skeleton height={24} width={192} />
							<Skeleton height={16} width={128} className="mt-1" />
						</div>
					</div>

					{/* Location */}
					<div className="flex gap-4">
						<Skeleton height={24} width={24} type="circle" />
						<div className="flex-1">
							<Skeleton height={24} width={192} />
							<Skeleton height={16} width={128} className="mt-1" />
						</div>
					</div>

					{/* Vehicle */}
					<div className="flex gap-4">
						<Skeleton height={24} width={24} type="circle" />
						<div className="flex-1">
							<Skeleton height={24} width={192} />
							<Skeleton height={16} width={128} className="mt-1" />
						</div>
					</div>

					{/* Cost */}
					<div className="flex gap-4">
						<Skeleton height={24} width={24} type="circle" />
						<div className="flex-1">
							<Skeleton height={24} width={192} />
							<Skeleton height={16} width={128} className="mt-1" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
